import Delta from 'quill-delta'
import diff from 'fast-diff';

export default function (before: string, after: string): Delta {
  const delta = new Delta()
  const diffResult = diff(before, after)
  diffResult.forEach((component: diff.Diff) => {
    switch (component[0]) {
      case diff.INSERT:
        delta.insert(component[1])
        break
      case diff.DELETE:
        delta.delete(component[1].length)
        break
      case diff.EQUAL:
        delta.retain(component[1].length)
        break
    }
  })
  return delta.chop()
}
